import {
  resolveSubscriptionPresentation,
} from "../../../utils/clubSubscriptionUi";
import ss from "./subscription.module.css";

const HERO_CLASS = {
  trial: ss.heroTrial,
  active: ss.heroActive,
  expiring: ss.heroWarn,
  unpaid: ss.heroUnpaid,
  expired: ss.heroUnpaid,
};

const BADGE_CLASS = {
  trial: "",
  active: ss.heroBadgeOk,
  expiring: ss.heroBadgeWarn,
  unpaid: ss.heroBadgeWarn,
  expired: ss.heroBadgeWarn,
};

const BAR_CLASS = {
  trial: "",
  active: ss.heroBarFillOk,
  expiring: ss.heroBarFillWarn,
  unpaid: ss.heroBarFillWarn,
  expired: ss.heroBarFillWarn,
};

export default function ClubSubscriptionStatusHero({ billing, clubName }) {
  const pres = resolveSubscriptionPresentation(billing, clubName);
  if (pres.variant === "loading") {
    return <p className={ss.pickerHint}>Загрузка подписки…</p>;
  }

  const heroTone = HERO_CLASS[pres.variant] || "";
  const badgeTone = BADGE_CLASS[pres.variant] || "";
  const barTone = BAR_CLASS[pres.variant] || "";

  return (
    <section className={`${ss.hero} ${heroTone}`}>
      <div className={ss.heroTop}>
        <div>
          <span className={`${ss.heroBadge} ${badgeTone}`}>{pres.badge}</span>
          <h3 className={ss.heroTitle}>{pres.title}</h3>
          <p className={ss.heroSubtitle}>{pres.subtitle}</p>
          <p className={ss.heroMeta}>{pres.meta}</p>
          {pres.ctaHint ? <p className={ss.heroMeta}>{pres.ctaHint}</p> : null}
        </div>
        {pres.progressLabel ? (
          <div className={ss.heroRing} aria-hidden>
            {pres.progressLabel}
          </div>
        ) : null}
      </div>
      {pres.progress != null ? (
        <div className={ss.heroBar} role="progressbar" aria-valuenow={pres.progress}>
          <div
            className={`${ss.heroBarFill} ${barTone}`}
            style={{ width: `${pres.progress}%` }}
          />
        </div>
      ) : null}
    </section>
  );
}
